import React, { useContext } from 'react';
import { Button, Typography, Banner } from '@up-riac/bespoke-ui';
import { GlobalDataContext } from 'src/lib/GlobalDataContext';
import { HeaderContext } from 'src/components/Header/components/HeaderContext';
import { useLocation } from 'react-router-dom';

export const UtilityHeader = ({ ...props }) => {
  const { activeAuctions } = useContext(GlobalDataContext);
  const location = useLocation();
  const { setLiveVideoOpen } = useContext(HeaderContext);
  const liveAuction = activeAuctions.find((auction) => auction.active);
  const liveAuctionIsTimed = liveAuction?.AuctionTypeID === TIMED_AUCTION_TYPE_ID;
  return (
    <div>
      {liveAuction && (
        <Banner.Global
          status='default' UNSAFE_className='bui:justify-center light max-w-full'
        >
          <div className='bui:flex bui:items-center bui:gap-2'>
            <div className='bg-[#22C55E] size-[10px] rounded-full' id='utility-live-auction-notice-indicator'>
              <div className='bg-[#22C55E] size-[10px] rounded-full animate-ping'/>
            </div>
            <Typography className='bui:text-white bui:font-productive bui:text-[16px] truncate'>
              {liveAuction.Title}
            </Typography>
            <Button
              to={liveAuctionIsTimed ? (
                (location.pathname.startsWith('/catalog/') || location.pathname.startsWith('/live'))
                  ? (
                    location.pathname.startsWith('/catalog/') ? (
                      undefined
                    ) : (
                      'https://rumble.com/user/RockIslandAuction'
                    )
                  ) : (
                    '/live/'
                  )
              )
                : '/live/'
              }
              title={liveAuction.Title}
              buttonType='outlined'
              invertColor
              size='sm'
              id={'utility-live-auction-notice-button'}
              className='shrink-0 light text-white border-white/25 hover:text-white hover:border-white/25'
              onPress={() => {
                setLiveVideoOpen(true);
              }}
            >
              {liveAuctionIsTimed ? 'Watch Broadcast' : 'Bid Live'}
            </Button>
          </div>
        </Banner.Global>
      )}
    </div>
  );
};
